import script from "./Info.vue?vue&type=script&setup=true&lang=tsx"
export * from "./Info.vue?vue&type=script&setup=true&lang=tsx"

import "./Info.vue?vue&type=style&index=0&id=3eb46986&scoped=true&lang=css"

import exportComponent from "/home/runner/work/The-Jojo-Tree/The-Jojo-Tree/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb46986"]])

export default __exports__